import React from 'react';
import PropTypes from 'prop-types';
import CanContext from './CanContext';

import User from '~/models/User';
import Incident from '~/models/Incident';

import StickyAlertContext from '~/containers/StickyAlertManager/StickyAlertContext';

class CanManager extends React.Component {
    static contextType = StickyAlertContext;
    constructor(props) {
        super(props);
        this.state = {
            permissionsLoaded: false,
            currentIncidentId: 0,
            permissions: {},
            currentIncidentPermissions: {},
            pendoInitialized: false,
        };
    }

    componentDidMount() {
        //RN: set new permissions
        User.getDetails(CURRENT_USER.id, true)
            .then(({ data }) => {
                const dataUser = data.data;
                const privilege = dataUser.permissions;

                CURRENT_USER.roles.newStackProfile.permissions = privilege;
                CURRENT_USER.roles.newStackProfile.roles = dataUser.roles;

                // update timezone infos
                CURRENT_USER.timezone = dataUser.timezone.value;
                CURRENT_USER.timezone_offset =
                    dataUser.timezone.timezone_offset;
                CURRENT_USER.offset2num = dataUser.timezone.offset2num;

                this.setState({
                    permissions: privilege,
                    permissionsLoaded: true
                });
                this.initializePendo();
            })
            .catch(exception => {
                console.error(exception);
            });
    }

    initializePendo() {
        const isValidDeployment = APP_INFO.deployment && APP_INFO.deployment !== 'None'; 
        if (
          !this.state.pendoInitialized &&
          isValidDeployment &&
          CURRENT_USER.mail &&
          window.pendo
        ) {
            const userId = parseInt(CURRENT_USER.id).toString(16).padStart(16, '0');
            const uniqueId = `${userId}-${APP_INFO.deployment}`;
            const orgId = parseInt(APP_INFO.org_id).toString(16).padStart(16, '0');
            window.pendo.initialize({
                visitor: {
                    id: uniqueId,
                    name: `${CURRENT_USER.name} ${CURRENT_USER.surname}`,
                    email: CURRENT_USER.mail,
                    sumo_user_id: userId
                },
                account: {
                    id: `${orgId}-${APP_INFO.deployment}`,
                    sumo_user_id: userId,
                    sumo_org_id: orgId,
                },
            });

            this.setState({ pendoInitialized: true });
        }
    }

    refreshIncidentPermissions = (
        incidentId,
        callback = () => {},
        roleChange = false
    ) => {
        if (incidentId && incidentId > 0) {
            Incident.getPermissions(incidentId)
                .then(response => {
                    const permissions = response.data;
                    this.setCurrentIncidentPermissions(
                        incidentId,
                        permissions,
                        callback,
                        roleChange
                    );
                })
                .catch(exception => {
                    console.error(exception);
                    callback?.();
                });
        } else {
            this.setState(
                {
                    currentIncidentId: 0,
                    currentIncidentPermissions: {}
                },
                callback
            );
        }
    };

    refreshPermissions = (changedPermissions, callback = () => {}) => {
        const refreshedPermissions = {
            ...CURRENT_USER.roles.newStackProfile.permissions,
            ...changedPermissions
        };

        CURRENT_USER.roles.newStackProfile.permissions = refreshedPermissions;
        this.setState(
            {
                permissions: { ...refreshedPermissions }
            },
            callback
        );
    };

    setCurrentIncidentPermissions = (
        incidentId,
        permissions,
        callback = () => {},
        roleChange = false
    ) => {
        // mm: if incident is not changed inhibit the update
        // bg: Also check if the role is not changed
        if (
            incidentId === parseInt(this.state.currentIncidentId) &&
            !roleChange
        ) {
            return;
        }
        this.setState(
            {
                currentIncidentId: incidentId,
                currentIncidentPermissions: permissions
            },
            callback
        );
    };

    render() {
        const { currentIncidentId, currentIncidentPermissions } = this.state;
        return (
            <CanContext.Provider
                value={{
                    currentIncidentId,
                    currentIncidentPermissions,
                    setCurrentIncidentPermissions: this
                        .setCurrentIncidentPermissions,
                    refreshIncidentPermissions: this.refreshIncidentPermissions,
                    refreshPermissions: this.refreshPermissions
                }}
            >
                {this.state.permissionsLoaded ? this.props.children : <></>}
            </CanContext.Provider>
        );
    }
}

CanManager.propTypes = {
    children: PropTypes.element
};

export default CanManager;
